var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../base/contentbase.service';
var TopComponent = /** @class */ (function (_super) {
    __extends(TopComponent, _super);
    function TopComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.componentName = TopComponent.name;
        _this.shopInfoNoData = false;
        _this.shopInfoList = [];
        return _this;
    }
    TopComponent.prototype.onSubscribe = function (data) {
        if (data.items.length > 0) {
            this.shopInfoList = data.items;
        }
        else {
            this.shopInfoNoData = true;
        }
    };
    TopComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    TopComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    TopComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    TopComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    TopComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    template: "<div class=\"l-module\">\n  <div class=\"top\">\n    <div class=\"top_list_area\">\n      <div *ngIf=\"shopInfoNoData\">{{ (msg | async)['TopComponent.label.nodata'] }}</div>\n      <div *ngFor=\"let shopInfo of shopInfoList\">\n        <h3>{{ shopInfo.title }}</h3>\n        <div class=\"date\">{{ shopInfo.start_date }}</div>\n        <div class=\"content\" [innerHtml]=\"shopInfo.contents\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    TopComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return TopComponent;
}(ContentBaseComponent));
export { TopComponent };
//# sourceMappingURL=top.component.js.map